export const API_BASE_URL = "https://systemhub.enminvithaigal.in/services/";
// http://localhost/SystemAdminConsole/services/apiCall.php
// export const API_BASE_URL = "./services/";
export const notification_types = {
    info : 'info',
    success : 'success',
    error : 'error',
    warning : 'warning'
}

